import { PageEvent } from '@angular/material/paginator';
import { MatPaginator } from '@angular/material/paginator';
import { filter, map, Observable } from 'rxjs';
import { paginate } from '../utils';
import { PIPE_ORDER, QtDataTransformAdapter } from './qt-control-adapter';

export interface PaginatorState {
  pageSize?: number;
}

export class PaginatorAdapter
  implements QtDataTransformAdapter<any, PaginatorState>
{
  readonly key = 'paginator';
  readonly pipeOrder = PIPE_ORDER.PAGINATE;

  private _suppress = false;

  readonly valueChanges$: Observable<PaginatorState> = this.paginator.page.pipe(
    filter(() => !this._suppress),
    map(e => ({ pageSize: e.pageSize }))
  );

  /** Full page event with suppress — for analytics use where pageIndex is needed. */
  readonly pageChanges$: Observable<PageEvent> = this.paginator.page.pipe(
    filter(() => !this._suppress)
  );

  readonly operator = paginate<any>(this.paginator, true);

  constructor(readonly paginator: MatPaginator) {}

  applyValue(value: PaginatorState): void {
    const pageSize = value?.pageSize;
    if (pageSize && this._isAllowedPageSize(pageSize)) {
      this._suppress = true;
      this.paginator._changePageSize(pageSize);
      this.paginator.firstPage();
      this._suppress = false;
    }
  }

  /** Saved sizes no longer offered by the paginator (e.g. removed "All") are rejected. */
  private _isAllowedPageSize(pageSize: number): boolean {
    const options = this.paginator.pageSizeOptions;
    return !options?.length || options.includes(pageSize);
  }

  getValue(): PaginatorState {
    return { pageSize: this.paginator.pageSize };
  }
}
